import { StylesClasses, commonStyles, createStyles } from '@utils/styles'

const styles = createStyles({
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '4px',
    height: '52px',
    width: '52px',
    borderRadius: '50%',
    backgroundColor: 'border.light',
  },
  icon: {
    height: '24px',
    width: '24px',
    '& img': {
      objectFit: 'contain !important',
    },
  },
  title: {},
  description: {},
  ratingContainer: {
    ...commonStyles.flexRow(1),
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
